import { ThemeColors } from '~/themes/colors'

interface PendingMessageBubbleColors {
  PendingBubble: {
    Sending: {
      Background: ThemeColors
      BackgroundGradient: ThemeColors
      BackgroundGradientAlt: ThemeColors
      StatusTextColor: ThemeColors
      TextColor: ThemeColors
    }
    Failed: {
      Background: ThemeColors
      StatusTextColor: ThemeColors
    }
  }
}
export const pendingMessageBubbleColors: PendingMessageBubbleColors = {
  PendingBubble: {
    Sending: {
      Background: {
        default: 'mask.blue.300.20',
      },
      BackgroundGradient: {
        default: 'mask.blue.300.40',
      },
      BackgroundGradientAlt: {
        default: 'blue.300',
      },
      StatusTextColor: {
        default: 'gray.900',
      },
      TextColor: {
        default: 'gray.1300',
      },
    },
    Failed: {
      Background: {
        default: 'red.200',
      },
      StatusTextColor: {
        default: 'red.500',
      },
    },
  },
}
